import docReady from 'doc-ready';
// import AjaxLoader from '../util/ajax_util';
// import {isLocalLink} from '../util/ajax_util';
import {videoEmbed} from '../util/video';
import {selectStyles} from '../util/jquery.formstyles';
import {initContainers, teardownContainers} from '../util/init';
import instafeed from './instafeed';
import quickSearchInit from './quick-search';
import hotspotMapInit from './hotspot';
import collectionFiltersInit from './collection/filters';
import {dealerSelectorRedirect} from './contact';
import {toggleEyebrow, collapseEyebrow} from './eyebrow';
import {trackNavigationTrigger, enableNavigationTrigger, recalculateNavigationTrigger} from './navigation';
import {updateLinkState} from '../util/link_state';
import {addHandler} from '../util/scroll_resize';
import {windowSize, lazyloadUnset, lazyloadSet} from '../util/miscellaneous';
import {fetchData} from '../shoptools/index';
import Packery from 'packery'; // docs https://packery.metafizzy.co/
import {flickity} from '../util/flickity';

import $ from 'jquery';

export const phonePortrait = 375;
export const phoneMax = 667;
export const tabletPortrait = 930;
export const tabletMax = 1100;
export const fluidMax = 1600;

let enableEyebrow = windowSize().width > phoneMax;
export let enablePackery = windowSize().width > phoneMax;
export let enableAjaxLoad = windowSize().width > tabletPortrait;
let flktyAsideLayoutInstances = [];

let enableScrollBalance = !window.Modernizr.touch && windowSize().width > tabletPortrait;

function setup () {
  // runs once at page load!
  // bind nav secondarytrigger
  document.querySelectorAll('nav .trigger-secondary').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (trigger.parentElement.classList.contains('open')) {
        document.querySelector('nav.primary').classList.remove('child-open')
        trigger.parentElement.classList.remove('open');
        recalculateNavigationTrigger();
      } else {
        document.querySelectorAll('nav .open').forEach((stale) => {
          stale.classList.remove('open');
        });
        document.querySelector('nav.primary').classList.add('child-open')
        trigger.parentElement.classList.add('open');
        recalculateNavigationTrigger();
      }

    });
  });
  // bind filters
  const filters = document.querySelectorAll('.collection-filters');
  filters.forEach(x => collectionFiltersInit(x));

  // bind quick search
  const quickSearchForm = document.querySelector('.eyebrow .search form');
  quickSearchInit(quickSearchForm);
  // bind dealer select
  const dealerSelector = document.querySelector('.site-footer .dealer-selector');
  dealerSelectorRedirect(dealerSelector);
  // bind eyebrow
  document.querySelectorAll('a[data-eyebrow]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      if (enableEyebrow) {
        e.preventDefault();
        toggleEyebrow(trigger);
      }
    });
  });
  // phone only, navigation trigger
  document.querySelector('.site-header .navigation-trigger').addEventListener('click', (e) => {
    if (enableNavigationTrigger) {
      e.preventDefault();
      if (document.body.classList.contains('navigation-visible')) {
        document.body.classList.remove('navigation-visible');
      } else {
        document.body.classList.add('navigation-visible');
      }
    }
  });
  // style select fields
  const selectFields = document.querySelectorAll('.site-footer select');
  selectStyles(selectFields);
  // track whether to show/not show navi trigger on phone
  trackNavigationTrigger();
  // header follow links
  document.querySelector('.site-header .follow-links-trigger').addEventListener('click', (e) => {
    e.preventDefault();
    if (document.querySelector('.site-header .follow-links').classList.contains('open')) {
      document.querySelector('.site-header .follow-links').classList.remove('open');
    } else {
      document.querySelector('.site-header .follow-links').classList.add('open');
    }
  });
  // init pages
  initContainers(document.querySelectorAll('#content > article'));
  // shoptools fetch
  fetchData();
  // init instagram
  const instagramFeed = document.querySelector('.instagram-feed .gallery');
  if (instagramFeed) {
    instafeed(instagramFeed, {
      // hashtag: ''
    }).then(() => {
      const flkty = flickity(instagramFeed, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    });
  }
  addHandler({
    resize: function (winWidth, winHeight) {
      enableEyebrow = winWidth > phoneMax;
      enablePackery = winWidth > phoneMax;
      enableAjaxLoad = winWidth > tabletPortrait;

      // phone, make aside story layouts into galleries, (assume only 1)
      document.querySelectorAll('.aside-layout').forEach((asideLayout) => {
        // const contentArticle = document.querySelector('#content > article');
        if ((winWidth < phoneMax && !asideLayout.classList.contains('flickity-enabled'))) {
            // (winWidth < tabletPortrait && asideLayout && !flktyAsideLayout &&
            // contentArticle.classList.contains('collection-collection', 'collection-product'))) {
          if (asideLayout.childElementCount > 1) {
            let flktyAsideLayout = flickity(asideLayout, {
              // options
              cellAlign: 'left',
              contain: true,
              pageDots: true,
              prevNextButtons: false
            });
            flktyAsideLayoutInstances.push(flktyAsideLayout);
          }
        } else if (flktyAsideLayoutInstances.length > 0) {
          flktyAsideLayoutInstances.forEach((flktyAsideLayout) => {
            flktyAsideLayout.destroy();
            flktyAsideLayoutInstances.pop(flktyAsideLayout);
          })

        }
      });
    },
    scroll: function (scrollY, scrollX) {
      if (enableEyebrow) {
        collapseEyebrow(scrollY);
      }
    }
  }, true);
}

export function commonInit (container) {
  // mask select boxes
  const selectFields = container.querySelectorAll('select');
  if (selectFields) {
    selectStyles(selectFields);
  }
  // init hotspot images (stories) currently assuming max one per page
  const hotspotMap = container.querySelector('.hotspot-map');
  if (hotspotMap) {
    hotspotMapInit(hotspotMap);
  }
  // setup youtube/vimeo video embeds
  container.querySelectorAll('.video-player .player').forEach((player) => {
    videoEmbed(player, player.getAttribute('data-video_url'));
  });
  // container.querySelectorAll('a[href]').forEach((ajaxTrigger) => {
  //   bindAjaxListener(ajaxTrigger);
  // });
  // update links
  updateLinkState(document.querySelectorAll('#header nav, #content aside'));

  if (enablePackery) {
    document.querySelectorAll('.mosaic-layout:not(.home-layout)').forEach((mosaicLayout) => {
      // initialise packery
      var pacMan = new Packery(mosaicLayout, {
        itemSelector: 'li'
      });
      // pacMan.once('layoutComplete', function () {
        // TODO dont reveal contennt until done
      // });
    });
  }

  // lazy load all images
  lazyloadSet(container);
  // wait a sec then fire load
  window.setTimeout(() => {
    lazyloadUnset(container);
  }, 10);

  addHandler({
    resize: function (winWidth, winHeight) {
      enableScrollBalance = !window.Modernizr.touch && windowSize().width > tabletPortrait;
      const balancethis = document.querySelector('aside .balance-this')

      if (enableScrollBalance && balancethis) {
        const allBalances = document.querySelectorAll('aside .balance-this')
        let top = 'calc(100vh - ' + balancethis.clientHeight + 'px)'
        if (allBalances.length === 1) {
          balancethis.style.top = top
        }
      }
    },
    scroll: function (scrollY, scrollX) {

    }
  }, true);
}

docReady(() => {
  // document ready
  setup();
  let container = document.querySelectorAll('#content');
  // run common init
  container.forEach((c) => {
    commonInit(c);
  });
  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      document.documentElement.classList.add('initialised');
    });
  }, 1000);
});



// WEBPACK FOOTER //
// ./assets/j/src/site.js